import { storage } from '../Services/storage';

const getUserInfo = () => {
  const user = storage.get('user');
  return user ? JSON.parse(user) : null;
};
export { getUserInfo };
